type PropsT = {
  className?: string
  fillColor?: string
}

// Filled paper-plane glyph ("sent" affordance). Same path as
// `img_paperPlane.svg`, which hardcodes its fill — this one takes a color.
const PaperPlane = (props: PropsT) => {
  const { className, fillColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M0.505849 8.14677L14.5165 0.13711C14.8293 -0.0506167 15.2671 -0.0506167 15.5798 0.168398C15.8926 0.387412 16.049 0.762865 15.9864 1.13832L13.9849 14.154C13.8911 14.7798 13.203 15.1865 12.6088 14.9362L8.73087 13.3093L6.79189 15.6558C6.60425 15.8748 6.32279 16 6.01005 16C5.44712 16 5.00928 15.562 5.00928 14.9988V11.7449L0.59967 9.93018C-0.150902 9.6173 -0.21345 8.55352 0.505849 8.14677ZM2.13209 8.92897L5.97877 10.5246L5.9475 10.4934L12.7965 2.82786L2.13209 8.92897ZM12.6088 13.3093L14.0787 3.64134L7.3861 11.1191L12.6088 13.3093Z"
        fill={fillColor}
      />
    </svg>
  )
}

export default PaperPlane
